export const Style = ({ colors = [] }) => (
  <g id="Estilo4_1_">
    <path
      style={{ fill: colors[0] }}
      d="M96.6,162l31.3-7.5l-8.4-35c-2.1-8.7-10.8-14-19.4-11.9l0,0c-8.7,2.1-14,10.8-11.9,19.4L96.6,162z"
    />
    <path
      style={{ fill: colors[0] }}
      d="M109.8,108.3l-11.9-6c-18.6,22.3-43.1,0.5-43.1,0.5l-18.3,8.4c-2.6,1.1-1,3.9-0.2,6.6l11.1,55.4 l58.5,0.3l6.3-57.6C113.1,113.2,112.6,109.3,109.8,108.3z"
    />
    <path
      style={{
        fill: 'none',
        stroke: '#000000',
        strokeWidth: '0.5',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeMiterlimit: '10'
      }}
      d=" M107.5,159.4c0,0,15.3-1.6,2.9-26.3"
    />
    <path
      style={{ fill: colors[0] }}
      d="M51.5,164l-31.3-7.5l8.4-35c2.1-8.7,10.8-14,19.4-11.9l0,0c8.7,2.1,14,10.8,11.9,19.4L51.5,164z"
    />

    <polyline
      style={{
        fill: 'none',
        stroke: '#000000',
        strokeWidth: '0.5',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeMiterlimit: '10'
      }}
      points=" 44.1,162.5 51.5,164 56.8,142.2 		"
    />
  </g>
)
